import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import CloseXIcon from 'assets/closeXOneMore.svg?react';
import SearchIcon from 'assets/search.svg?react';

interface Props {
  setSearch: (value: string) => void;
}

export const SearchBar = ({ setSearch }: Props) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);
    setSearch(value);
  };

  const clearInput = () => {
    setInputValue('');
    setSearch('');
  };

  return (
    <div className="relative w-full self-end lg:w-[18.75rem]">
      <div className="relative flex items-center rounded-[0.5rem] border-2 border-border bg-indigo lg:rounded-[1.5rem]">
        <input
          className="block w-full overflow-hidden text-ellipsis rounded-[1.5rem] bg-transparent px-4 py-2 text-md text-violet-text placeholder-white/40 outline-none sm:text-lg lg:max-w-[16.875rem]"
          placeholder={t('pages.liveGamesSection.search')}
          value={inputValue}
          onChange={handleInputChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          style={{
            direction: !isFocused && inputValue ? 'rtl' : 'ltr',
            textAlign: 'left',
          }}
        />
        {inputValue && (
          <button type="button" className="absolute right-4 flex items-center" onClick={clearInput}>
            <CloseXIcon />
          </button>
        )}
        {!inputValue && (
          <SearchIcon className="pointer-events-none absolute right-4 w-4 text-white" />
        )}
      </div>
    </div>
  );
};
